import { useSonarSelector } from '../useSonarSelector';
import { createAsyncSelectors, createSonarSelector } from '@lib/selectors';
const empty = [];
const latestSyncSelectors = createAsyncSelectors((state) => state.imports.latest.salesforce);
const singleSyncSelector = createSonarSelector((state) => { var _a; return ((_a = latestSyncSelectors.data(state)) !== null && _a !== void 0 ? _a : empty)[0]; });
function compare(prev, next) {
    if ((!prev && next) || (prev && !next)) {
        return false;
    }
    if (!prev && !next) {
        return true;
    }
    return (prev.id === next.id &&
        prev.status === next.status &&
        prev.finishedOn === next.finishedOn &&
        prev.logs.length === next.logs.length);
}
export function useLatestSalesforceSync() {
    return useSonarSelector(singleSyncSelector, compare);
}
